import Vue from 'vue'

class Security {
  async login({data}) {
    return await Vue.axios
      .post('app/security/login', data)
  }

  async logout() {
    return await Vue.axios
      .delete('app/security/logout')
  }
}

const security = new Security()

export default security
